export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.26-0953.09",
  commitId: "a4e9c9090c59fe3eb154407400406ef9ee2bd450",
  commitTime: "2026-06-26T09:53:09.000Z",
});
